export function parseJsonFromDataAttributeEncoded<T>(element: HTMLElement, datasetName: string): T | undefined {
   const attributeValue = element.dataset[datasetName];
   if (attributeValue) {
      try {
         return JSON.parse(atob(attributeValue)) as T;
      }
      catch (ex) {
         console.log("Exception decoding data attribute value: ", ex);
      }
   }
   return undefined;
}